const init_require_customize = () => {
    const _loading = document.querySelector(".rc_loading");
    _loading.style.display = "none";
  
    const _btn_require_customize = document.querySelector(".prod-require-customize");
    _btn_require_customize.addEventListener("click", (event) => {
        const _rc_main = document.querySelector(".rc-back-drop");
        _rc_main.style.display = "block";
        var body = document.body;
        body.classList.add("bsh");
    });
    const _close_require_customize = document.querySelector(".close_require_customize");
    _close_require_customize.addEventListener("click", (event) => {
        const _rc_main = document.querySelector(".rc-back-drop");
        _rc_main.style.display = "none";
        //reset form
        reset_form_require_customize();
    });
    const _btn_submit_require_customize = document.querySelector(".rc-form-btn");
    _btn_submit_require_customize.addEventListener("click", (event) => {
        doAddRequireCustomize();
    });

    const _email = document.getElementById("rc_email");
    _email.addEventListener("input", (event) => {
        _email.classList.remove("input-error");
    })

    const _phone_number = document.getElementById("rc_phone_number");
    _phone_number.addEventListener("input", (event) => {
        _phone_number.classList.remove("input-error");
    })

    const _message = document.getElementById("require-customize-message");
    _message.addEventListener("input", (event) => {
        _message.classList.remove("input-error");
    })
}

const reset_form_require_customize = () => {  
    var body = document.body;
    body.classList.remove("bsh");
    const _btn_submit_require_customize = document.querySelector(".rc-form-btn");
    _btn_submit_require_customize.style.display = "block";
    const _success_message = document.querySelector(".rc-form-success");
    _success_message.style.display = "none";

    const _email = document.getElementById("rc_email");
    const _phone_number = document.getElementById("rc_phone_number");
    const _message = document.getElementById("require-customize-message");

    _email.value = "";
    _phone_number.value = "";
    _message.value = "";

    _email.classList.remove("input-error");
    _phone_number.classList.remove("input-error");
    _message.classList.remove("input-error");
}

const doAddRequireCustomize = async () => {
    //hidden submit button
    const _loading = document.querySelector(".rc_loading");
    _loading.style.display = "flex";
    const _btn_submit_require_customize = document.querySelector(".rc-form-btn");
    _btn_submit_require_customize.style.display = "none";
  
    const _email = document.getElementById("rc_email");
    const _phone_code = document.getElementById("rc_phone_code");
    const _phone_number = document.getElementById("rc_phone_number");
    const _message = document.getElementById("require-customize-message");

    const _success_message = document.querySelector(".rc-form-success");

    if (_email.value == "") {
        _email.classList.add("input-error");
        return
    }
    if (_phone_number.value == "") {
        _phone_number.classList.add("input-error");
        return
    }
    if (_message.value == "") {
        _message.classList.add("input-error");
        return
    }

    const payload = {};
    payload.product_id = _btn_submit_require_customize.dataset.produuct;
    payload.product_name = _btn_submit_require_customize.dataset.productName;
    payload.product_vendor = _btn_submit_require_customize.dataset.productVendor;
    payload.email = _email.value;
    payload.phone_number = _phone_code[_phone_code.selectedIndex].text + _phone_number.value;
    payload.message = _message.value;
    const url = "https://easterncurator-app.vercel.app/api/requirecustomize";
    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    })
        .then((response) => response.json())
        .then(async (response) => {
            console.log(response);
            _loading.style.display = "none";
            _btn_submit_require_customize.style.display = "none";
            _success_message.style.display = "block";
        });
}

init_require_customize();